import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';
import React from 'react';
import './FeaturedThemesCardSectionSkeleton.scss';

const FeaturedThemesCardSectionSkeleton = () => {
  const featuredCardsSkeleton = Array(4)
    .fill(1)
    .map((_, i) => i + 1);

  return (
    <Flex className={'custom-swiper-card-external-skeleton-container'}>
      <Flex className={'custom-header-and-description-container'}>
        <SkeletonText
          noOfLines={1}
          skeletonHeight="7"
          className={'custom-skeleton-title'}
        />
        <SkeletonText
          noOfLines={1}
          skeletonHeight="5"
          className={'custom-skeleton-description'}
        />
      </Flex>

      <Flex className={'featured-cards-skeleton-container'}>
        {featuredCardsSkeleton.map(key => (
          <Flex
            className={'custom-swiper-card-inner-skeleton-container'}
            key={key}
          >
            <Flex>
              <Skeleton className={'custom-swiper-card-skeleton-image'} />
            </Flex>

            <SkeletonText
              noOfLines={1}
              skeletonHeight="5"
              className={'custom-swiper-card-skeleton-header'}
            />

            <SkeletonText
              noOfLines={3}
              skeletonHeight="3"
              className={'custom-swiper-card-skeleton-description'}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default FeaturedThemesCardSectionSkeleton;
